import { render, staticRenderFns } from "./JDictSelectTag.vue?vue&type=template&id=33375052&scoped=true"
import script from "./JDictSelectTag.vue?vue&type=script&lang=js"
export * from "./JDictSelectTag.vue?vue&type=script&lang=js"
import style0 from "./JDictSelectTag.vue?vue&type=style&index=0&id=33375052&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33375052",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33375052')) {
      api.createRecord('33375052', component.options)
    } else {
      api.reload('33375052', component.options)
    }
    module.hot.accept("./JDictSelectTag.vue?vue&type=template&id=33375052&scoped=true", function () {
      api.rerender('33375052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dict/JDictSelectTag.vue"
export default component.exports